import { AuthEventData } from '@aws-amplify/ui';
import { AmplifyUser } from '@aws-amplify/ui/dist/types/types/authenticator/user';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Router from 'pages/router';

function AuthenticatedApp({
  user,
  signOut
}: {
  user: AmplifyUser | undefined;
  signOut: ((data?: AuthEventData | undefined) => void) | undefined;
}): JSX.Element {
  const location = useLocation();
  useEffect(() => {
    if (process.env.REACT_APP_SEGMENT_WRITE_KEY !== undefined) {
      window.analytics.page();
    }
  }, [location.pathname]);

  if (process.env.REACT_APP_PENDO_API_KEY !== undefined) {
    window.pendo.initialize({
      visitor: {
        id: user?.username,
        email: user?.attributes?.email,
        family_name: user?.attributes?.family_name,
        given_name: user?.attributes?.given_name,
        company_name: user?.attributes?.['custom:company_name']
      },
      account: {
        id: user?.username
      }
    });
  }

  return <Router user={user} signOut={signOut} />;
}

export default AuthenticatedApp;
